// import store from '../store'

export default [
  // router => (to, from) => {
  //   store.dispatch('PAGEVIEW', { to, from })
  // },
]
